var initializeCarouselVideoBlock = function(block){
	
	jQuery('.slick').on('init', function(event, slick){
	  var dots = jQuery( '.slick-dots li' );
	  console.log( 'SRANZAN VEE' );
	  dots.each( function( k, v){
		$(this).find( 'button' ).addClass( 'heading'+ k );
	  });
	  var items = slick.$slides;
	  items.each( function( k, v){
		  var text = $(this).find( 'h2' ).text();
		  $( '.heading' + k ).text(text);
	  });
	});
	
	
	jQuery('.slick', block).slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		rows: 1,
		slidesPerRow: 1,
		dots: true,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false, 
		infinite: true,
		draggable: false,
		swipe: true,
		adaptiveHeight: false,
		customPaging : function(slider, i) {
			var title = jQuery(slider.$slides[i]).data('title');
			return '<a class="pager__item"> '+title+' </a>';
		}
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-carousel-video').each(function(){
		initializeCarouselVideoBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=carousel-video', initializeCarouselVideosBlock);
